import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { Button, Card, Col, Row } from 'reactstrap';
import CreateBrandProfileMainPage from '../../../StoreOverview_v1/Scenes/Components/SubComponents/Questionnaire/CreateBrandProfileMainPage';
import LoadingOverlay from 'react-loading-overlay';

import Loader from 'react-loaders';
import FetchAllCategoryAndSubCategoryService from '../../../../../../Service/DashboardServices/AssetGalleryServices/FetchAllCategoryAndSubCategoryService';
import ImageAndLogo from '../../../StoreOverview_v1/Scenes/Components/SubComponents/AssetGallery_v2/Components/Components/Brand/ImageAndLogo';
import GetFileListBySubCategoryService from '../../../../../../Service/DashboardServices/AssetGalleryServices/GetFileListBySubCategoryService';
import OtherBrandAsset from '../../../StoreOverview_v1/Scenes/Components/SubComponents/AssetGallery_v2/Components/Components/Brand/OtherBrandAsset';
import VideosForBrand from '../../../StoreOverview_v1/Scenes/Components/SubComponents/AssetGallery_v2/Components/Components/Brand/VideosForBrand';
import UploadImagesAndOriginalFiles from '../../../StoreOverview_v1/Scenes/Components/SubComponents/AssetGallery_v2/Components/Components/UploadImagesAndOriginalFiles';
import UploadVideosPage from '../../../StoreOverview_v1/Scenes/Components/SubComponents/AssetGallery_v2/Components/Components/Brand/UploadVideosPage';
import UploadAllTypeOfAssetsFile from '../../../StoreOverview_v1/Scenes/Components/SubComponents/AssetGallery_v2/Components/Components/UploadAllTypeOfAssetsFile';
import GetBrandProfileListService from '../../../../../../Service/DashboardServices/QuestionnaireServices/GetBrandProfileListService';
function ProjectsDashBrandsMainFile(props) {
  const [subCategories, setSubCategories] = useState()
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const [fileStatus, setFileStatus] = useState('')
  const [filterSubcategoryList, setFilterSubcategoryList] = useState()
  const [selectedSubCategories, setSelectedSubCategories] = useState('')
  const [isInfoTabOpen, setIsInfoTabOpen] = useState(false)
  const [uploadProjectAssetsUi,setUploadProjectAssetsUi]= useState(false)
  const [brandProfile,setBrandProfile]= useState([])
  const [selectedBrand, setSelectedBrand]= useState(props.selectedProjectData?props.selectedProjectData.brand:'')
  const [selectedBrandId,setSelectedBrandId]= useState(props.selectedProjectData?props.selectedProjectData.brandId:'')
  const [selectedBrandDetails,setSelectedBrandDetails]=useState('')


  useEffect(() => {
    console.log(props.selectedProjectData);
    setLoading(true)
    let data = {
      integerId: props.storeOverview.integerID,
      assetIdentifier:''
    };
    FetchAllCategoryAndSubCategoryService(props.token,data).then((res)=>{
      if(res){
        const filteredSubcategories = res.subCategory.filter(sub => sub.assetCategory === 1);
        setSubCategories(res.subCategory)
        const defaultTab = filteredSubcategories.find(sub => sub.subCategoryName === "Questionnaire") || filteredSubcategories[0];
      if (defaultTab) {
        handleSelectedSubtabs(defaultTab); 
        setSelectedSubCategories(defaultTab); 
      }
      }
    })
    GetBrandProfileListService(props.token,data).then((response) => {
      if (response) {
        console.log(response);
          setBrandProfile(response.brandList);
          
      }
  });
  }, [props.page]);
  const handleBrandChange=(e)=>{
    console.log(e.target.value);
    setSelectedBrand(e.target.value)
    const brand = brandProfile && brandProfile.find((b) => (b.brandName) === e.target.value);
    console.log(brand);
        setSelectedBrandId(brand.id);
        setSelectedBrandDetails(brand)
        const questionnaireTab = subCategories.find(sub => sub.subCategoryName === "Questionnaire");
        if (questionnaireTab) {
          setSelectedSubCategories(questionnaireTab);
    }
      
    }

  const handleSelectedSubtabs = (tabs) => {
    console.log(tabs);
    setSelectedSubCategories(tabs)
    setLoading(true)
    // 1-> Questionnaire and 3-> Assets
    if (tabs.id != 3 || tabs.id != 1) {
      console.log('if condition');
      let data = {
        integerId: props.selectedProjectData.integerId,
        assetCategory: tabs.assetCategory,
        assetIdentifier:selectedBrand ,
        subCategoryId: tabs.id,
        // projectId:props.selectedProjectData.projectId,

      }

      GetFileListBySubCategoryService(props.token, data).then((response) => {
        if (response) {
          console.log(response);
        setFileList(response.fileList)
          setFileStatus(response.statusList)
          setFilterSubcategoryList(response.subcategoryList)
          setLoading(false) 
        }
      })
    }
   
  }
  const handleOpenFileInfo = () => {
    setIsInfoTabOpen(!isInfoTabOpen)   
}
const uploadProjectAssets=()=>{
  setUploadProjectAssetsUi(true)
}
const handleBackFromUploadAssetsImages=()=>{
  setUploadProjectAssetsUi(false)
 }
const renderUploadAssetsPage = () => {

  //subCategoryId =6 Media - Live amazon images 7=>Media - Product photos 8=>Media - Lifestyle photos 11=>Media - Packaging images 12=>Media - Other images
  
      if (selectedSubCategories.id ==1 || selectedSubCategories.id == 2) {
        console.log(selectedSubCategories.id)
        return (
              <UploadImagesAndOriginalFiles
                  subCategoryId={selectedSubCategories.id}
                  handleBackFromUploadAssetsImages={handleBackFromUploadAssetsImages}
                  assetIdentifier={selectedBrand}
                  setFileListOfAssets={setFileList}
                  assetCategory = {1} />
          )
      }
        else if(selectedSubCategories.id ==13){
          return(
            <UploadVideosPage
            subCategoryId={selectedSubCategories.id}
            handleBackFromUploadAssetsImages={handleBackFromUploadAssetsImages}
            assetIdentifier={selectedBrand}
            fileListOfAssetsVideo={fileList}
            setFileListOfAssetsVideo={setFileList}
            setFileListOfAssets={setFileList}
            assetCategory = {1}
            />
          )
        }
  
      else {
          return (
              <UploadAllTypeOfAssetsFile
                  subCategoryId={selectedSubCategories.id}
                  handleBackFromUploadAssets={handleBackFromUploadAssetsImages}
                  setFileListOfAssets={setFileList}
                  setAllFileListOfAssets={setFileList}
                  flagNumber={10}
                  assetIdentifier={selectedBrand} 
                  assetCategory = {1}/>
          )
      }
  }
  return (
    
    <>
    {
      uploadProjectAssetsUi?
      renderUploadAssetsPage():
      <>
     <Card className='card-of-problemarea p-2 mt-3 ml-3'>
          <Row className="mt-3">
          <Col md={12} className='ml-2 d-flex justify-content-between'>
                    <div>
                            <b>Brand :</b>{' '}
                            <select 
                                className='form-control d-inline-block'
                                value={selectedBrand}
                                onChange={(e) => handleBrandChange(e)}
                                style={{ width: 'auto', display: 'inline-block', marginLeft: '5px' }}
                            >
                                <option value="">--Select Brand--</option>
                                {brandProfile &&brandProfile.map((brand, index) => (
                                <option key={brand.id || index} value={brand.brandName}>
                                    {brand.brandName}
                                </option>
                                ))}
                            </select>
                            </div>
                            {
                              (selectedBrand !== '' && selectedBrand !== null && selectedSubCategories.id !== 18 && props.projectPermissions.BrandAssets_Modifications) &&
                              <Button
                               className="btn-background-color-Proceed-gallery mr-3"
                                onClick={uploadProjectAssets}>
                                Upload Assets
                              </Button>
                            }

                           
                            </Col>
            <Col md={12} className='mt-4'>
              <div className="brand-tabs ml-3 mb-4">
                {/* 3 ==assetCategory  Projects */}
                {subCategories && subCategories.filter(sub => sub.assetCategory === 1).map((sub) => {
                  // const isActive = contentTeamActiveSubTab.id === sub.id;
                  const isActive = selectedSubCategories.id === sub.id;
                  return (
                    <span
                      className={`main-tabs ${isActive ? 'active' : ''}`}
                      onClick={() => { handleSelectedSubtabs(sub); }}>
                      {sub.subCategoryName}
                    </span>
                  );
                })}
              </div>
            </Col>
          </Row>
          </Card>
         
            <LoadingOverlay
            active={loading}
            styles={{
              overlay: (base) => ({
                ...base,
                background: '#fff',
                opacity: 1,
              }),
              content: (base) => ({
                ...base,
                color: '#000',
              }),
            }}
            spinner={<Loader active type="ball-pulse" />}
            text='Loading your Assets...'
          >
        {  (selectedSubCategories &&selectedSubCategories.subCategoryName == "Images" ||selectedSubCategories &&selectedSubCategories.subCategoryName =="Logo")&&
        <ImageAndLogo
            brand={props.selectedProjectData}
            handleOpenFileInfo={handleOpenFileInfo}
            isInfoTabOpen={isInfoTabOpen}
            setIsInfoTabOpen={setIsInfoTabOpen}
            subCategoryId={selectedSubCategories.id} 
            fileListOfAssets={fileList} 
            setFileListOfAssets={setFileList}
            UserPermission={props.projectPermissions}
            assetCategory={1}
        />
        }
         {  (selectedSubCategories &&selectedSubCategories.subCategoryName == "Brand Guidelines" ||selectedSubCategories &&selectedSubCategories.subCategoryName =="Corporate Docs" ||selectedSubCategories &&selectedSubCategories.subCategoryName =="Reference Docs" ||selectedSubCategories &&selectedSubCategories.subCategoryName == "Interview" ||selectedSubCategories && selectedSubCategories.subCategoryName == 'Audit' )&&
        <OtherBrandAsset
        allFileListOfAssets={fileList}
        brand={props.selectedProjectData}
        subCategoryId={selectedSubCategories.id} 
        fileListOfAssets={fileList} 
        UserPermission={props.projectPermissions}
        setAllFileListOfAssets={setFileList}
        setFileListOfAssets={setFileList}
        assetCategory={1}
        />
    }
     {selectedSubCategories &&selectedSubCategories.subCategoryName == "Videos" &&
        <VideosForBrand
          catId={1}
          UserPermission={props.projectPermissions}
          assetIdentifier={props.selectedProjectData.brand?props.selectedProjectData.brand:''}
          fileListOfAssetsVideo={fileList}
          setFileListOfAssetsVideo={setFileList}
          handleOpenFileInfo={handleOpenFileInfo}
          isInfoTabOpen={isInfoTabOpen}
          setIsInfoTabOpen={setIsInfoTabOpen}
          subCategoryId={selectedSubCategories.id} 
          fileListOfAssets={fileList}
          setFileListOfAssets={setFileList}
          assetCategory={1}
        />
      }

      {/* {(selectedSubCategories &&selectedSubCategories.subCategoryName == "Interview" ||selectedSubCategories && selectedSubCategories.subCategoryName == 'Audit'  ) &&
        <ProjectDashBrandInterviewAndAudit
        OtherBrandAsset
          fileList={fileList}
          setFileList={setFileList}
          fileStatus={fileStatus}
          selectedProjectData={props.selectedProjectData}
          selectedSubCategories={selectedSubCategories}
          filterSubcategoryList={filterSubcategoryList}
        />
      } */}
      {/* {selectedSubCategories &&selectedSubCategories.subCategoryName == "Assets" &&
        <ProjectDashAssets
          brand={props.selectedBrand}
          subCategories={selectedSubCategories.id}
          selectedProjectData={props.selectedProjectData}
          selectedSubCategories={selectedSubCategories}
          // token={props.token}
          // storeOverview={props.storeOverview}
          catId={1}
        />
      } */}
      {selectedSubCategories &&selectedSubCategories.subCategoryName == "Questionnaire" &&
        <CreateBrandProfileMainPage
          selectbrandId={selectedBrandId}
          categoryID={1}
          UserPermission={props.projectPermissions}
          key={selectedBrandId}
          // brand={selectedBrandDetails}
          showBrandInfo={false}
          refreshUseEffect={selectedBrandId}
        />
      }
    
     
 </LoadingOverlay>
 </>
          }
      
    </>
  )
}
const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
  UserPermission: state.accountOverview.store.StoreUserPermission,
});

export default connect(mapStateToProps)(ProjectsDashBrandsMainFile);
